/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./change-volume-btn.vue?vue&type=template&id=3762a9a6&scoped=true&"
import script from "./change-volume-btn.vue?vue&type=script&lang=js&"
export * from "./change-volume-btn.vue?vue&type=script&lang=js&"
import style0 from "./change-volume-btn.vue?vue&type=style&index=0&id=3762a9a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3762a9a6",
  null
  
)

export default component.exports